import React from "react";
import { useSpecialFunctions } from "../../functions";
import Rights from "../../constants/Rights";

const OpenBetsChartTable = ({
  openBetsChartInfo,
  selectedTicketsVoidScore = [],
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
}) => {
  const userRightsList = JSON.parse(localStorage.getItem("UserRights")) || [];
  const { getTimeInfo, getDateInfo } = useSpecialFunctions();
  let headers,
    tableContent = [];

  const hasSelectAllPermissions = () =>
    userRightsList.some((right) =>
      [Rights.FRM_VOID_TICKET, Rights.FRM_SCORE_TICKETS].includes(
        right.FormName
      )
    );

  const ticketsChangeHandler = (ticketID) => {
    if (!hasSelectAllPermissions()) {
      return;
    }
    if (selectedTicketsVoidScore.includes(ticketID)) {
      // If the id is already in the list, it deletes it.
      setSelectedTicketsVoidScore(
        selectedTicketsVoidScore.filter((item) => item !== ticketID)
      );
    } else {
      // If the id is not in the list, it adds it.
      setSelectedTicketsVoidScore([...selectedTicketsVoidScore, ticketID]);
    }
  };

  const handleSelectAll = () => {
    const allTicketIDs = openBetsChartInfo.map((item) => item.TicketID);

    if (selectAllTickets) {
      setSelectedTicketsVoidScore([]);
    } else {
      setSelectedTicketsVoidScore(allTicketIDs);
    }

    setSelectAllTickets(!selectAllTickets);
  };

  //Charge Open Bets Table
  if (openBetsChartInfo) {
    tableContent = openBetsChartInfo.map((data, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={"tr" + data.TicketNumber}
            style={{
              cursor: hasSelectAllPermissions() ? "pointer" : "inherit",
              verticalAlign: "middle",
            }}
            onClick={() => ticketsChangeHandler(data.TicketID)}
            className={
              selectedTicketsVoidScore.includes(data.TicketID)
                ? "shadedRow"
                : ""
            }
          >
            <td className="d-none">{data.IdWager}</td>

            <td
              key={"td" + data.TicketNumber}
              style={{
                textAlign: "center",
                width: "100px",
                verticalAlign: "middle",
              }}
            >
              {getDateInfo(data.PlacedDateTime)} <br />
              {getTimeInfo(data.PlacedDateTime)}
            </td>
            <td
              key={"userPl" + data.IdWager}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
                width: "100px",
              }}
            >
              {data.AccountUserName}
            </td>

            <td
              key={"desc" + data.IdWager}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                width: "450px",
              }}
            >
              {data.TicketDesc} {data.Selections}
            </td>

            <td
              key={"td"}
              style={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              {data.TotalStake} / {data.WinPaid}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  headers = (
    <tr className="text-center">
      <th hidden>TicketID</th>
      <th style={{ width: "150px" }}>Placed</th>
      <th>Account</th>
      <th>Description</th>
      <th>Risk / Win</th>
      {/* <th></th> */}
    </tr>
  );

  return (
    <div style={{ height: "500px", overflow: "auto", marginTop: "10px" }}>
      <div className="form-check mb-1">
        <input
          type="checkbox"
          className="form-check-input"
          id="exampleCheck1"
          checked={selectAllTickets}
          onChange={handleSelectAll}
          disabled={
            openBetsChartInfo?.length === 0 || !hasSelectAllPermissions()
          }
        />
        <label
          className="form-check-label"
          htmlFor="exampleCheck1"
          style={{ color: "#8c8c8c", fontSize: "16px" }}
        >
          Select All Tickets
        </label>
      </div>
      <table className="table table-sm">
        <thead style={{ position: "sticky", top: "0", background: "white" }}>
          {headers}
        </thead>
        <tbody className="table-sm">{tableContent}</tbody>
      </table>
    </div>
  );
};

export default OpenBetsChartTable;
